module.exports = __webpack_public_path__ + "img/time.fdb558f2.svg";